import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody46.css';

import clientimg from '../images/case-study-client46.webp'
import outcome from '../images/outcome46.webp'

import sm1 from '../images/cs46so11.webp'
import sm2 from '../images/cs46so12.webp'
import sm3 from '../images/cs46so13.webp'
import sm4 from '../images/cs46so21.webp'
import sm5 from '../images/cs46so22.webp'
import sm6 from '../images/cs46so31.webp'
import sm7 from '../images/cs46so32.webp'
import sm8 from '../images/cs46so41.webp'
import sm9 from '../images/cs46so42.webp'
import sm10 from '../images/cs46so43.webp'


const Casestudybody46 = () => {

    return (
        <>
        <section className='casestudybody46-section'>
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A strategic holding company operating across the technology, real estate, and prop-tech sectors, with a focus on building and scaling high-value ventures </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client plans to develop a digital platform to support its operational and strategic objectives and requires a detailed Business Requirements Document (BRD) to guide its development</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody46-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Understanding Requirements:</h4>
                          <p>Conducted initial scoping discussions with key stakeholders to <span style={{color:"#03A393",fontWeight:700}}> define the objectives of the digital platform and align on the overall vision.</span> Identified core user groups, their expected functionalities, and system requirements to ensure the BRD captures both business and technical perspectives</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Requirement Structuring:</h4>
                          <p>Mapped out user journeys and process flows to <span style={{color:"#03A393",fontWeight:700}}> translate business needs into structured functional and non-functional requirements.</span> Defined use cases, data inputs, and interaction points for each module of the platform</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Document Development:</h4>
                          <p>Prepared the Business Requirements Document (BRD) detailing <span style={{color:"#03A393",fontWeight:700}}> platform objectives, user types, process flows, and feature specifications.</span> Ensured traceability between business needs and system requirements for development alignment</p>
                        </div>
                      </div>
    
                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Validation & Finalization:</h4>
                          <p>Conducted review sessions with the client's core team to <span style={{color:"#03A393",fontWeight:700}}> validate assumptions and incorporate feedback.</span> Finalized the BRD to serve as the baseline reference for subsequent design and development phases</p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <div className='frow'>
                          <img src={sm1} alt=''/>
                          <img src={sm2} alt=''/>
                          <img src={sm3} alt=''/>
                        </div>
                        <div className='mrow'>
                          <img src={sm4} alt=''/>
                          <img src={sm5} alt=''/>
                          <img src={sm6} alt=''/>
                          <img src={sm7} alt=''/>
                        </div>
                        <div className='lrow'>
                          <img src={sm8} alt=''/>
                          <img src={sm9} alt=''/>
                          <img src={sm10} alt=''/>
                        </div>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody46-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered a comprehensive Business Requirements Document (BRD) detailing functional and non-functional requirements, platform features, user workflows, and system specifications to guide development and ensure stakeholder alignment</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody46
